module.exports = __webpack_public_path__ + "img/theme5.0bfe05bc.png";